const faCrosshairs = {
  prefix: 'fal',
  iconName: 'crosshairs',
  icon: [
    576,
    512,
    [],
    'f05b',
    'M288-16c8.8 0 16 7.2 16 16l0 32.6C415 40.4 503.6 129 511.4 240l32.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32.6 0C503.6 383 415 471.6 304 479.4l0 32.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32.6C161 471.6 72.4 383 64.6 272L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l32.6 0C72.4 129 161 40.4 272 32.6L272 0c0-8.8 7.2-16 16-16zM96.7 272c7.7 93.3 82.1 167.6 175.3 175.3l0-47.3c0-8.8 7.2-16 16-16s16 7.2 16 16l0 47.3c93.3-7.7 167.6-82.1 175.3-175.3L432 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l47.3 0C471.6 146.7 397.3 72.4 304 64.7l0 47.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-47.3C178.7 72.4 104.4 146.7 96.7 240l47.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-47.3 0zM288 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
  ],
};
export default faCrosshairs;
